import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { IAccountUser } from '@account-users/account/models/IAccountUser';
import { UserRoles } from '@account-users/account/models/UserRoles';
import { AccountSettings } from '@account-users/account/models/AccountSettings';
import { AccountUserType } from '@account-users/account/models/AccountUserType';
import { LicenseCode } from '@account-users/account/models/LicenseCode';
import { IToolInfo } from '@account-users/account/models/IToolInfo';
import { isAdmin } from '@account-users/utils';
import { LICENSES_WITH_ICONS } from '@account-users/account/models/LicensePackage';
import { Permission } from '@account-users/account/models/Permission';
import { LicenseV2 } from '@account-users/account/state/feature-toggles/models';
import * as moment from 'moment';

@Component({
  selector: 'app-account-user-list',
  templateUrl: './account-user-list.component.html',
  styleUrls: ['./account-user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountUserListComponent {
  @HostBinding('class.disabled') @Input() disabled: boolean;
  @Input() users: IAccountUser[] = [];
  @Input() icon: string = null;
  @Input() accountSettings: AccountSettings;
  @Input() listTitle: string;
  @Input() accountId: string;
  @Input() allLicenses: LicenseV2[];
  @Input() usersCount: number;
  @Input() deactivated = false;
  @Input() support = false;
  @Input() hasWawRole = false;
  @Input() isDownloadingReport = false;

  @Output() openDeleteFromAccountModal = new EventEmitter<IAccountUser>();
  @Output() downloadReport = new EventEmitter<void>();

  public UserTypes = AccountUserType;

  hasIcon(tool: LicenseCode) {
    return LICENSES_WITH_ICONS.includes(tool);
  }

  getAccountLicenses() {
    return this.allLicenses.filter((license) => license.enabled);
  }

  getExpireTooltip(user) {
    return user.expires
      ? `Active until ${moment(user.expires).format('YYYY-MM-DD')}
      ${moment(user.expires).format('HH:mm')}`
      : '';
  }

  getToolIcon(toolPermissions: IToolInfo[], toolId: LicenseCode) {
    const tool = toolPermissions.find((tp) => tp.toolId === toolId);
    return tool &&
      (tool.permissions.includes(Permission.CanSwitch) ||
        tool.permissions.includes(Permission.CanManage))
      ? `tool-icons/${toolId}`
      : `tool-icons/${toolId}-inactive`;
  }

  getIsAdmin(toolPermissions: IToolInfo[]) {
    return isAdmin(toolPermissions);
  }

  copyUserId(id) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = id;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  isOnlyUser(roles: UserRoles) {
    return !!(roles.length === 1 && roles.includes(UserRoles.User));
  }
}
